domUtil = exports

domUtil.isVerticallyVisibleWithin = (elem, relative_to) =>
    # Check if element is visible vertically
    container = $(elem).closest(relative_to)
    contHeight = container.height()
    contTop = container.scrollTop()
    contBottom = contTop + contHeight

    if container.offset()?
        elemTop = $(elem).offset().top - container.offset().top
        elemBottom = elemTop + $(elem).height()

        isTotal = (elemTop >= 0 and elemBottom <= contHeight)
        isPart = ((elemTop < 0 and elemBottom > 0 ) or (elemTop > 0 and elemTop <= container.height()))

        return isTotal or isPart
